<template>
  <Popup
    close-icon-class="dark"
    @close="closePlayer"
  >
    <VideoPlayer
      :video="url"
      :width="width"
      :height="height"
      :autoplay="autoplay"
    />
  </Popup>
</template>

<script>
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import Popup from '~/components/Common/Popup/Popup';

export default {
  components: {
    Popup,
    VideoPlayer,
  },
  props: {
    video: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 1000,
    },
    height: {
      type: Number,
      default: 562.5,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close'],

  computed: {
    url() {
      if (this.video.includes('youtube.com') && !this.video.includes('embed')) {
        return this.video.replace('watch?v=', 'embed/');
      } else if (
        this.video.includes('youtu.be') &&
        !this.video.includes('embed')
      ) {
        return this.video.replace('youtu.be/', 'youtube.com/embed/');
      }

      return this.video;
    },
  },

  methods: {
    closePlayer() {
      this.$emit('close');
    },
  },
};
</script>
